import api from './base'
import { objectToQueryString } from '../utils/object'

export default {
  user ({ electronicDevice, businessUnit, dateFrom, dateTo, user }) {
    let url = `user_report?dateFrom=${dateFrom}&dateTo=${dateTo}`
    if (user) {
      url += `&user=${user}`
    }
    if (electronicDevice) {
      url += `&electronicDevice=${electronicDevice}`
    }
    if (businessUnit) {
      url += `&businessUnit=${businessUnit}`
    }
    return api().get(url)
  },
  article ({ electronicDevice, businessUnit, dateFrom, dateTo, user, categories }) {
    let url = `article_report?dateFrom=${dateFrom}&dateTo=${dateTo}`
    if (electronicDevice) {
      url += `&electronicDevice=${electronicDevice}`
    }
    if (businessUnit) {
      url += `&businessUnit=${businessUnit}`
    }
    if (user) {
      url += `&user=${user}`
    }
    if (categories) {
      url += `&categories=${categories}`
    }
    return api().get(url)
  },
  category ({ electronicDevice, businessUnit, dateFrom, dateTo, includeArticles, user, filters }) {
    let url = `category_report?dateFrom=${dateFrom}&dateTo=${dateTo}`
    if (includeArticles) {
      url += `&includeArticles=${includeArticles}`
    }
    if (electronicDevice) {
      url += `&electronicDevice=${electronicDevice}`
    }
    if (businessUnit) {
      url += `&businessUnit=${businessUnit}`
    }
    if (user) {
      url += `&user=${user}`
    }
    if (filters) {
      url += `&${objectToQueryString(filters)}`
    }
    return api().get(url)
  },
  daily_sell_report ({ electronicDevice, businessUnit, dateFrom, dateTo, user }) {
    let url = `daily_sell_report?dateFrom=${dateFrom}&dateTo=${dateTo}`
    if (electronicDevice) {
      url += `&electronicDevice=${electronicDevice}`
    }
    if (businessUnit) {
      url += `&businessUnit=${businessUnit}`
    }
    if (user) {
      url += `&user=${user}`
    }
    return api().get(url)
  },
  daily_sell_report_pdf ({ electronicDevice, businessUnit, dateFrom, dateTo }) {
    let url = `daily_sell_report/pdf?dateFrom=${dateFrom}&dateTo=${dateTo}`
    if (electronicDevice) {
      url += `&electronicDevice=${electronicDevice}`
    }
    if (businessUnit) {
      url += `&businessUnit=${businessUnit}`
    }
    return api().get(url)
  }
}
